import React from 'react';
import { ShieldCheck, Zap, Lock, CreditCard } from 'lucide-react';
export function BuySection() {
  return <section id="comprar" className="py-16 px-4 bg-brand-base relative" data-id="element-33">
      <div className="max-w-xl mx-auto bg-brand-light rounded-2xl p-6 md:p-10 border-2 border-accent-base shadow-[0_0_40px_rgba(232,93,44,0.15)] text-center relative overflow-hidden" data-id="element-34">
        <h2 className="text-2xl md:text-3xl font-oswald font-bold text-white uppercase mb-2" data-id="element-35">
          Empezá tu transformación hoy
        </h2>
        <p className="text-gray-300 mb-6" data-id="element-36">
          Acceso inmediato a los 3 tomos + 3 bonos exclusivos.
        </p>

        <div className="mb-8" data-id="element-37">
          <p className="text-gray-400 text-lg line-through mb-1" data-id="element-38">
            Precio normal: $52.690
          </p>
          <div className="flex justify-center items-start gap-1" data-id="element-39">
            <span className="text-accent-base text-2xl font-bold mt-2" data-id="element-40">$</span>
            <span className="text-white text-6xl font-oswald font-bold tracking-tight" data-id="element-41">
              19.990
            </span>
            <span className="text-gray-400 text-sm mt-8 ml-1" data-id="element-42">ARS</span>
          </div>
        </div>

        <a href="https://checkout.ebookpoint.shop/cart/59526388777041:1" className="block w-full bg-accent-base hover:bg-accent-dark text-white font-oswald text-2xl py-5 px-8 rounded-xl shadow-[0_10px_20px_rgba(232,93,44,0.3)] transition-all transform hover:-translate-y-1 hover:shadow-[0_15px_30px_rgba(232,93,44,0.4)] active:translate-y-0 uppercase tracking-wide mb-6" data-id="element-43">
          QUIERO CAMBIAR MI JUEGO
        </a>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-44">
          <div className="flex flex-col items-center gap-2" data-id="element-45">
            <Lock className="w-6 h-6 text-gray-400" data-id="element-46" />
            <span className="text-xs text-gray-400" data-id="element-47">Pago 100% Seguro</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-48">
            <Zap className="w-6 h-6 text-gray-400" data-id="element-49" />
            <span className="text-xs text-gray-400" data-id="element-50">Acceso Inmediato</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-51">
            <ShieldCheck className="w-6 h-6 text-gray-400" data-id="element-52" />
            <span className="text-xs text-gray-400" data-id="element-53">Garantía 7 días</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-54">
            <CreditCard className="w-6 h-6 text-gray-400" data-id="element-55" />
            <span className="text-xs text-gray-400" data-id="element-56">Todos los medios</span>
          </div>
        </div>
      </div>
    </section>;
}